import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, from, map, Observable, switchMap, throwError } from "rxjs";
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from "@azure/msal-browser";
import { SocialAuthService } from '@abacritt/angularx-social-login';
export enum LoginType {
  NORMAL = 'NORMAL',
  GOOGLE = 'GOOGLE',
  LINKEDIN = 'LINKEDIN',
  MICROSOFT = 'M365'
}

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    constructor(private http: HttpClient,private msalService: MsalService, private socialAuthService: SocialAuthService){}

    login(body:any){
        return this.http.post<string[]>(`employees/portal/signin`, body).pipe(
            catchError((error) => {
                return throwError(() => error);
            })
        )
    }

    verifyOtp(body:any){
        return this.http.post(`employees/portal/verify-otp`,body)
    }

    resendOtp(body:any){
        return this.http.post(`employees/portal/generate-otp`,body)
    }

    socialSignIn(body:any){
        return this.http.post(`employees/portal/social-signin`,body)
    }

    signInWithOffice365(): Observable<any> {
        const loginRequest = {
            scopes: ['user.read', 'profile', 'openid', 'email']
        };

        return from(this.msalService.initialize()).pipe(
            switchMap(() => this.msalService.loginPopup(loginRequest)),
            switchMap((response: AuthenticationResult) => {
                return this.socialSignIn({code: response.accessToken,socialSignInType: LoginType.MICROSOFT})
            }),
            catchError(error => {
                console.error('MSAL Error:', error);
                return throwError(() => error);
            })
        );
    }

    getLoginType(): LoginType {
        return (localStorage.getItem('loginType') as LoginType) || LoginType.NORMAL;
    }

    isLoggedIn(): boolean {
        return !!localStorage.getItem('token');
    }

    getCurrentLoginProvider(): string {
        const loginType = this.getLoginType();
        switch (loginType) {
            case LoginType.GOOGLE:
                return 'Google';
            case LoginType.LINKEDIN:
                return 'LinkedIn';
            case LoginType.MICROSOFT:
                return 'Microsoft';
            default:
                return 'Email';
        }
    }

    async logoutGoogle(): Promise<void> {
        try {
            await this.socialAuthService.signOut();
        } catch (error) {
            console.error('Google logout error:', error);
        }
    }

    async logoutMicrosoft(): Promise<void> {
        try {
            await this.msalService.logoutPopup({
                postLogoutRedirectUri: window.location.origin
            });
        } catch (error) {
            console.error('Microsoft logout error:', error);
        }
    }
}